/*!
 * MONTVIELLE — homepage behaviour (mv-home.js)
 * Scroll reveals and one-tap add for one-size products. Everything else is CSS or native HTML.
 */
(() => {
  'use strict';

  /* Reveal on scroll — skipped entirely when the visitor asks for reduced motion. */
  const reveal = () => {
    const items = document.querySelectorAll('.mv-reveal:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach((el) => el.classList.add('is-in'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    items.forEach((el) => observer.observe(el));
  };

  /* One-size products add straight to the bag; the cart drawer opens itself. */
  document.addEventListener('click', async (e) => {
    const button = e.target.closest('[data-mv-quickadd]');
    if (!button) return;
    e.preventDefault();
    const id = button.dataset.mvQuickadd;
    const label = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      if (window.MV && window.MV.cart) await window.MV.cart.add(id, 1);
      else document.dispatchEvent(new CustomEvent('mv:cart:add', { detail: { id, quantity: 1 } }));
      button.textContent = 'Added';
      setTimeout(() => { button.textContent = label; button.disabled = false; }, 1600);
    } catch (error) {
      button.textContent = label;
      button.disabled = false;
    }
  });

  document.addEventListener('shopify:section:load', reveal);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal, { once: true });
  else reveal();
})();
